import { useState } from 'react';
import { Outlet } from 'infrastructure/router';
// @mui
import { Box } from '@mui/material';
// hooks
import useResponsive from 'hooks/useResponsive';
// components
import { useSettingsContext } from 'lib/settings';
//
import Settings from "ui/layouts/Settings";
import Main from './Main';
import Header from './header';
import NavMini from './nav/NavMini';
import NavVertical from './nav/NavVertical';
import NavHorizontal from './nav/NavHorizontal';
import { useUnsavedChanges } from 'hooks';
import useDashboardBootstrap from 'hooks/useDashboardBootstrap';
import withRedirect from './withRedirect';
import withBoostrap from './withBootstrap';
import type { DashboardProps } from './types';

// ----------------------------------------------------------------------

const Dashboard = ({ useBootstrap = useDashboardBootstrap }: DashboardProps) => {
  const { themeLayout } = useSettingsContext();

  useBootstrap();
  useUnsavedChanges();

  const isDesktop = useResponsive('up', 'lg');

  const [open, setOpen] = useState(false);

  const isNavHorizontal = themeLayout === 'horizontal';

  const isNavMini = themeLayout === 'mini';

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const renderNavVertical = <NavVertical openNav={open} onCloseNav={handleClose} />;

  if (isNavHorizontal) {
    return (
      <Settings>
        <Header onOpenNav={handleOpen} />

        {isDesktop ? <NavHorizontal /> : renderNavVertical}

        <Main>
          <Outlet />
        </Main>
      </Settings>
    );
  }

  if (isNavMini) {
    return (
      <Settings>
        <Header onOpenNav={handleOpen} />

        <Box
          sx={{
            display: { lg: 'flex' },
            minHeight: { lg: 1 },
          }}
        >
          {isDesktop ? <NavMini /> : renderNavVertical}

          <Main>
            <Outlet />
          </Main>
        </Box>
      </Settings>
    );
  }

  return (
    <Settings>
      <Header onOpenNav={handleOpen} />

      <Box
        sx={{
          display: { lg: 'flex' },
          minHeight: { lg: 1 },
        }}
      >
        {renderNavVertical}

        <Main>
          <Outlet />
        </Main>
      </Box>
    </Settings>
  );
};

export default  withBoostrap(withRedirect(Dashboard));
